import { ButtonLink, Column, Row, Typography } from '@/components'
import { Breakpoint, ThemeColor } from '@/enums'
import { themeBreakpointDown, themeColor, toThemePixels } from '@/utils'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  width: 100%;
  gap: ${toThemePixels(4)};

  > * {
    width: calc(50% - ${toThemePixels(3)});

    input {
      width: 100%;
    }
  }

  ${themeBreakpointDown(Breakpoint.sm)} {
    flex-direction: column;
    gap: ${toThemePixels(1)};

    > * {
      width: 100%;
    }
  }
`

export const SuccessContainer = styled(Column)`
  gap: ${toThemePixels(6)};
  padding-top: ${toThemePixels(8)};

  button {
    width: fit-content;
  }
`

export const KillerQuestionsList = styled.ul`
  > li {
    list-style: none;
    margin-bottom: ${toThemePixels(2)};
  }
`

export const NumberedListCounter = styled(Typography).attrs({
  variant: 'description',
  color: ThemeColor.info1,
})`
  border-radius: 100px;
  flex-shrink: 0;
  background: ${themeColor(ThemeColor.info4)};
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const UnderlinedButtonLink = styled(ButtonLink)`
  text-decoration: underline;
  text-underline-offset: 2px;
  color: ${({ theme }) => theme.color.info1};
  height: auto;

  &:hover {
    color: ${({ theme }) => theme.color.info1};
  }
`
